/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { makeStyles, Box, Button, FormHelperText } from "@material-ui/core";
import Page from "../../components/Page";
import TableEquipos from "./components/Equipos/TableEquipos";
import AddIcon from "@material-ui/icons/Add";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import PersonAddDisabledIcon from "@material-ui/icons/PersonAddDisabled";
import sedeactual from "../../config/sedeactual";
import AddEquipos from "./components/Equipos/AddEquipos";
import { getFixedAssets, getCategoryType, getLocations } from "./requests";
import SelectLocations from "./SelectLocations";
import LoaderBackdrop from "../../components/Global/LoaderBackdrop";
import { Dropdown, notification } from "antd";
import { MenuDropDown } from "./Memorandums";
import ExportarExcel from "../../components/Global/ExportarExcel";

const useStyles = makeStyles(() => ({
  buttonDisable: {
    margin: "10px 0",
    backgroundColor: "#f0f0f0",
    color: "#BD1214",
  },
  buttonEnable: {
    margin: "10px 0",
    backgroundColor: "#f0f0f0",
    color: "#4caf50",
  },
}));

const typeAsset = "machinery";

const Equipos = () => {
  const classes = useStyles();
  const [idLocation, setIdLocation] = useState(null);
  const [nameLocation, setNameLocation] = useState(null);
  const [equipos, setEquipos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [visibleModalAdd, setVisibleModalAdd] = useState(false);
  const [categories, setCategories] = useState([]);
  const [isActive, setIsActive] = useState(true);
  const [locations, setLocations] = useState([]);
  const [memorandum, setMemorandum] = useState({
    open: false,
    type: "",
    data: [],
    keys: [],
  });

  const obtainData = async () => {
    try {
      const res = await getCategoryType(typeAsset);
      res.sort((a, b) => (a.name < b.name ? -1 : 1));
      setCategories(res);
    } catch (error) {
      notification["error"]({
        message: "Ocurrió un error al obtener la información.",
        description: `${error}`,
      });
    }
  };

  const obtainAssets = async () => {
    setLoading(true);
    try {
      const result = await getFixedAssets(
        typeAsset,
        sedeactual.get(),
        isActive,
        idLocation
      );
      setEquipos(result);
    } catch (error) {
      notification["error"]({
        message: "Ocurrió un error al obtener la información.",
        description: `${error}`,
      });
    } finally {
      setLoading(false);
    }
  };

  const obtainLocation = async () => {
    setLoading(true);
    try {
      const res = await getLocations();
      setLocations(res.data);
      if (res.data.length > 0) {
        setIdLocation(res.data[0]._id);
        setNameLocation(res.data[0].name);
      }
    } catch (error) {
      notification["error"]({
        message: "Ocurrió un error al obtener la información.",
        description: `${error}`,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    obtainData();
    obtainLocation();
  }, []);

  useEffect(() => {
    if (idLocation) {
      obtainAssets();
      const result = locations.find((e) => e._id === idLocation);
      setNameLocation(result.name);
    }
  }, [idLocation, isActive]);

  return (
    <Page
      title="EQUIPOS Y MAQUINARIA"
      helper="INVENTARIO"
      itemComponent={
        <>
          <Dropdown
            overlay={
              <MenuDropDown
                onClick={(e) =>
                  setMemorandum({ ...memorandum, open: true, type: e.key })
                }
              />
            }
            disabled={
              memorandum.data.length === 0 || sedeactual.getRol() === "usuario"
            }
          >
            <Button color="primary" variant="contained">
              MEMORANDUM
            </Button>
          </Dropdown>{" "}
          <Button
            className={!isActive ? classes.buttonEnable : classes.buttonDisable}
            variant="contained"
            onClick={() => setIsActive(!isActive)}
            disabled={!idLocation ? true : false}
          >
            {!isActive ? <PersonAddIcon /> : <PersonAddDisabledIcon />}{" "}
            {!isActive ? "HABILITADO" : "DESHABILITADO"}
          </Button>{" "}
          <Button
            variant="contained"
            color="primary"
            onClick={() => setVisibleModalAdd(true)}
            disabled={ sedeactual.getRol() === "usuario" || (idLocation ? false : true)}
          >
            <AddIcon /> AGREGAR
          </Button>{" "}
          <ExportarExcel
            name={`EQUIPOS_Y_MAQUINARIAS_${Date.now().toString()}`}
            endpoint={`export-fixed-asset/${sedeactual.get()}/${typeAsset}/${idLocation}/${
              sedeactual.company().url
            }`}
            method="GET"
            disabled={loading || idLocation ? false : true}
            small={false}
            api={2}
          />
        </>
      }
    >
      {loading && <LoaderBackdrop />}
      {visibleModalAdd && (
        <AddEquipos
          visible={visibleModalAdd}
          setVisible={setVisibleModalAdd}
          reloadFunction={obtainAssets}
          categories={categories}
          idLocation={idLocation}
          sede={sedeactual.get()}
          setLoading={setLoading}
          loading={loading}
          company={sedeactual.company().url}
        />
      )}
      <FormHelperText>LOCACIONES</FormHelperText>
      <SelectLocations
        defaultValue={idLocation}
        onChangeSelect={(e) => setIdLocation(e)}
        data={locations}
      />
      <Box pb={1} />
      <TableEquipos
        onlyview={sedeactual.getRol() === "usuario"}
        dataTable={equipos}
        reloadFunction={obtainAssets}
        idLocation={idLocation}
        setLoading={setLoading}
        loading={loading}
        categories={categories}
        isActive={isActive}
        nameLocation={nameLocation}
        memorandum={memorandum}
        setMemorandum={setMemorandum}
      />
    </Page>
  );
};

export default Equipos;
